
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObcPoiObjectVessel as ObcPoiObjectVesselElement} from '@oicl/openbridge-webcomponents/dist/ar/poi-object-vessel/poi-object-vessel.js';
 
 
 

 
 export const ObcPoiObjectVessel = createComponent({
   react: React,
   tagName: 'obc-poi-object-vessel',
   elementClass: ObcPoiObjectVesselElement,
   events: {
     
   }
  });
 
 